import { FC, memo, useState } from 'react'
import { Tooltip, Center, Text } from '@chakra-ui/react'

import { useCalendarFilters } from '../../../../../../contexts/CalendarFiltersManager/Provider'
import calculateDatesDifferenceInDays from '../../../../../../localUtils/calculateDatesDifferenceInDays'
import { isDateBetweenDatesRanger } from '../../../../../../localUtils/isDateBetweenDatesInterval'

type Props = {
  day: number
  stringDate: string
  isThisMounth: boolean
}

const CalendarNumber: FC<Props> = ({ day, stringDate, isThisMounth }) => {
  const [tooltipLabel, setTooltipLabel] = useState('')

  const { startDate, setStartDate, finalDate, setFinalDate } = useCalendarFilters()

  const isBetweenRangerDates = isDateBetweenDatesRanger({ currentDate: stringDate, startDate, finalDate })

  const getDaysOnMouseEnter = () => {
    const days = Math.abs(calculateDatesDifferenceInDays(stringDate, finalDate))
    let text = ''
    if (days == 0) text = 'Nenhum dia'
    if (days == 1) text = `${days} dia`
    text = `${days} dias`
    setTooltipLabel(text)
  }

  const isSelectedDate = stringDate === startDate || stringDate === finalDate

  let textColor = 'dark'
  let bgColor = 'light'

  if (isBetweenRangerDates) bgColor = 'lightPrimary'

  if (isSelectedDate) {
    textColor = 'light'
    bgColor = 'primary'
  }

  if (!isThisMounth) {
    return <Center boxSize="8" rounded="sm" />
  }

  const handleSetFinalDate = (newStringDate: string) => {
    console.log('EndCalendar newStringDate', newStringDate)
    const daysAboveFinalDate = calculateDatesDifferenceInDays(newStringDate, finalDate)
    console.log('EndCalendar daysAboveFinalDate', daysAboveFinalDate)
    if (daysAboveFinalDate === 0) return setFinalDate(newStringDate)

    if (daysAboveFinalDate > 0) {
      setStartDate(newStringDate)
    } else {
      setFinalDate(newStringDate)
    }
  }

  return (
    <>
      {tooltipLabel ? (
        <Tooltip hasArrow label={tooltipLabel} placement="top" color="light" bg="primary">
          <Center
            opacity={isThisMounth ? '1' : '0'}
            boxSize="8"
            rounded="sm"
            transition="all 250ms"
            cursor="pointer"
            bg={bgColor}
            color={textColor}
            _hover={{ bg: 'primary', color: 'light' }}
            onClick={() => handleSetFinalDate(stringDate)}
            onMouseOver={getDaysOnMouseEnter}
          >
            <Text>{day}</Text>
          </Center>
        </Tooltip>
      ) : (
        <Center
          opacity={isThisMounth ? '1' : '0'}
          boxSize="8"
          rounded="sm"
          transition="all 250ms"
          cursor="pointer"
          bg={bgColor}
          color={textColor}
          _hover={{ bg: 'primary', color: 'light' }}
          onClick={() => handleSetFinalDate(stringDate)}
          onMouseOver={getDaysOnMouseEnter}
        >
          <Text>{day}</Text>
        </Center>
      )}
    </>
  )
}

export default memo(CalendarNumber)
